import {
	FETCH_ORDERS,
	FETCH_ORDERS_SUCCESS,
	FETCH_ORDERS_FAIL,
	FETCH_ORDER,
	FETCH_ORDER_SUCCESS,
	FETCH_ORDER_FAIL,
	SET_ORDERS_META,
	SET_ORDER_ROWS_META
} from '../constants/ActionTypes';


export const fetchOrders = (eventID) => {
	return {
		type: FETCH_ORDERS,
		loading: true,
		eventID: eventID
	};
};

export const fetchOrdersSuccess = (orders, ordersMeta) => {
	return {
		type: FETCH_ORDERS_SUCCESS,
		orders: orders,
		ordersMeta: ordersMeta,
		loading: false
	};
};

export const fetchProductsFail = (error) => {
	return {
		type: FETCH_ORDERS_FAIL,
		error: error,
		loading: false
	};
};

export const fetchOrder = (orderID) => {
	return {
		type: FETCH_ORDER,
		loading: true,
		orderID: orderID
	};
};

export const fetchOrderSuccess = (order) => {
	return {
		type: FETCH_ORDER_SUCCESS,
		order: order,
		loading: false
	};
};

export const fetchOrderFail = (error) => {
	return {
		type: FETCH_ORDER_FAIL,
		error: error,
		loading: false
	};
};

export const setOrdersMeta = (meta) => {
	return {
		type: SET_ORDERS_META,
		meta: meta,
		metaLoaded: true
	};
};

export const setOrderRowsMeta = (orderRowsMeta) => {
	return {
		type: SET_ORDER_ROWS_META,
		orderRowsMeta: orderRowsMeta,
		orderRowsMetaLoaded: true
	};
};
